﻿import { useBookDemo } from './BookDemoContext'
import './sections.css'
export default function GetStartedSection() {
  const openBookDemo = useBookDemo()
  const steps = [
    { n: 1, title: 'Book a Demo', desc: 'See PossoBuild in action with your actual use cases. 30-minute personalized walkthrough.' },
    { n: 2, title: 'Start a Pilot', desc: 'Test with 2–3 high-volume roles or departments. 60-day pilot with guaranteed results.' },
    { n: 3, title: 'See Results', desc: 'Faster hiring, better retention, validated learning. Most customers see ROI in the first month.' },
  ]
  return (
    <section className="section get-started-section">
      <div className="container">
        <h2 className="section-title">Ready to Transform Your Talent Strategy?</h2>
        <p className="section-subtitle">Three steps to AI-powered employee intelligence.</p>
        <div className="get-started-steps">
          {steps.map(s => (
            <div key={s.n} className="step-card">
              <div className="step-number-large">{s.n}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="get-started-cta">
          <button className="btn-primary btn-large" onClick={() => openBookDemo('Book a Demo')}>Book Your Demo</button>
          <a href="/how-it-works" className="btn-secondary btn-large">Learn How It Works →</a>
        </div>
      </div>
    </section>
  )
}
